import { styled } from '@vr/ds-react'

export const BoxContent = styled('div', {
  display: 'flex',
  flexDirection: 'column !important',
  justifyContent: 'center !important',
  gap: 15,
  backgroundColor: '$neutralVeryLight',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '$neutralMedium',
  borderRadius: '$borderRadiusSmall',
  fontSize: '$extraSmall',
  fontWeight: '$semiBold',
  lineHeight: '$extraLarge',
  padding: '$sm16',
  marginBottom: '$sm16'
})
